import { MEASUREMENT_UNIT_PAGE } from "routes/route.constant";
import MeasurementUnit from "./MeasurementUnit";

const route = {
  path: MEASUREMENT_UNIT_PAGE,
  element: MeasurementUnit,
};

export default route;
